// import { UserContextService } from './../../core/services/user-context.service';
import { Component, OnInit, AfterViewInit, ViewChild, Input } from '@angular/core';
// import { ToastService } from '../../core/services/toast.service';
// import { LoaderService } from '../../core/services/loader.service';
import { MenuDataService } from '../../core/services/menu-data.service';
import { CustomMenuItem } from '../../core/models/menu-item.model';
import { Sidebar } from 'primeng/sidebar';
import { ApplicationStateService } from '../../core/services/application-state.service';
// import { RouteStateService } from '../../core/services/route-state.service';
// import { CommonService } from 'src/app/core/services/common.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements AfterViewInit, OnInit {

  groupID: string;
  // Menu GL
  itemsGLSetup: CustomMenuItem[];
  itemsGLInput: CustomMenuItem[];
  itemsGLProcess: CustomMenuItem[];
  itemsGLReport: CustomMenuItem[];
  itemsGLInquiry: CustomMenuItem[];

  // Menu AP
  itemsAPSetup: CustomMenuItem[];
  itemsAPInput: CustomMenuItem[];
  itemsAPProcess: CustomMenuItem[];
  itemsAPReport: CustomMenuItem[];
  itemsAPInquiry: CustomMenuItem[];

  // Menu AR
  itemsARSetup: CustomMenuItem[];
  itemsARInput: CustomMenuItem[];
  itemsARProcess: CustomMenuItem[];
  itemsARReport: CustomMenuItem[];
  itemsARInquiry: CustomMenuItem[];

  // Menu CA
  itemsCASetup: CustomMenuItem[];
  itemsCAInput: CustomMenuItem[];
  itemsCAProcess: CustomMenuItem[];
  itemsCAReport: CustomMenuItem[];
  itemsCAInquiry: CustomMenuItem[];

  // Menu FA
  itemsFASetup: CustomMenuItem[];
  itemsFAInput: CustomMenuItem[];
  itemsFAProcess: CustomMenuItem[];
  itemsFAReport: CustomMenuItem[];
  itemsFAInquiry: CustomMenuItem[];

  // Menu IN
  itemsINSetup: CustomMenuItem[];
  itemsINInput: CustomMenuItem[];
  itemsINProcess: CustomMenuItem[];
  itemsINReport: CustomMenuItem[];

  // Menu SA
  itemsSASetup: CustomMenuItem[];
  itemsSAInput: CustomMenuItem[];
  itemsSAReport: CustomMenuItem[];

  // Menu PO
  itemsPOInput: CustomMenuItem[];
  itemsPOProcess: CustomMenuItem[];
  itemsPOReport: CustomMenuItem[];

  // Menu SO
  itemsSOInput: CustomMenuItem[];
  itemsSOProcess: CustomMenuItem[];
  itemsSOReport: CustomMenuItem[];

  // Menu EInvoice
  itemsEISetup: CustomMenuItem[];
  itemsEIInput: CustomMenuItem[];
  itemsEIProcess: CustomMenuItem[];

  // Menu SI
  itemsSIInput: CustomMenuItem[];

  // Menu UF
  itemsUFInput: CustomMenuItem[];
  // Menu ST
  itemsSTInput: CustomMenuItem[];
  itemsSTSecurity: CustomMenuItem[];
  // Menu BG
  itemsBGInput: CustomMenuItem[];
  itemsBGReport: CustomMenuItem[];

  // Menu SP Approval System
  itemsSPInput: CustomMenuItem[];
  itemsSPReport: CustomMenuItem[];
  
  // Menu CP
  itemsCPFinancialStatement: CustomMenuItem[];
  itemsCPCustomers: CustomMenuItem[];
  itemsCPVendors: CustomMenuItem[];
  itemsCPRevenues: CustomMenuItem[];
  itemsCPCost: CustomMenuItem[];
  itemsCPAnalyze: CustomMenuItem[];
  itemsCPManagements: CustomMenuItem[];
  itemsCPHumanResources: CustomMenuItem[];

  isMenuVisible: boolean;

  showGL: boolean;
  showAP: boolean;
  showAR: boolean;
  showCA: boolean;
  showFA: boolean;
  showIN: boolean;
  showSA: boolean;
  showSO: boolean;
  showPO: boolean;
  showEI: boolean;
  showSI: boolean;
  showST: boolean;
  showUF: boolean;
  showBG: boolean;
  showSP: boolean;
  showAS: boolean;
  showHR: boolean;
  showCP: boolean;
  showCPN: boolean;

  isMobileResolution: boolean = false;

  @ViewChild("menubar", { static: true }) menubar: Sidebar;

  constructor(
    // private toastService: ToastService,
    // private loaderService: LoaderService,
    private menuDataService: MenuDataService,
    // private routeStateService: RouteStateService,
    // private userContextService: UserContextService,
    private applicationStateService: ApplicationStateService,
    private localStorageService: LocalStorageService,
  ) {
  }

  ngOnInit() {
    // const routeState = this.routeStateService.getCurrent();
    // this.groupID = routeState.data; // assign when click login ( login component )

    //this.groupID = this.userContextService.user$.value.GroupID;
    let accessModules : string = this.localStorageService.getItem("AccessModule");
    let access : string[] = accessModules.split(',');
    access.forEach(element =>{
      if(element == "GL"){
        this.showGL = true;
      }
      else if(element == "AP"){
        this.showAP = true;
      }
      else if(element == "AR"){
        this.showAR = true;
      }
      else if(element == "CA"){
        this.showCA = true;
      }
      else if(element == "FA"){
        this.showFA = true;
      }
      else if(element == "IN"){
        this.showIN = true;
      }
      else if(element == "SO"){
        this.showSO = true;
      }
      else if(element == "PO"){
        this.showPO = true;
      }
      else if(element == "SA"){
        this.showSA = true;
      }
      else if(element == "SI"){
        this.showSI = true;
      }
      else if(element == "ST"){
        this.showST = true;
      }
      else if(element == "UF"){
        this.showUF = true;
      }
      else if(element == "BG"){
        this.showBG = true;
      }
      else if(element == "EI"){
        this.showEI = true;
      }
      else if(element == "SP"){
        this.showSP = true;
      }
      else if(element == "AS"){
        this.showAS = true;
      }
      else if(element == "HR"){
        this.showHR = true;
      }
      else if(element == "CP"){
        this.showCP = true;
      }
    })
    
    this.groupID = 'EVERYONE';
    // this.loaderService.show();
    // MenuGL 
    this.itemsGLSetup = this.menuDataService.getMenuGLSetup(this.localStorageService.getItem("AccessFoGL"));
    this.itemsGLInput = this.menuDataService.getMenuGLInput(this.localStorageService.getItem("AccessFoGL"));
    this.itemsGLProcess = this.menuDataService.getMenuGLProcess(this.localStorageService.getItem("AccessFoGL"));
    this.itemsGLReport = this.menuDataService.getMenuGLReport(this.localStorageService.getItem("AccessFoGL"));
    this.itemsGLInquiry = this.menuDataService.getMenuGLInquiry(this.localStorageService.getItem("AccessFoGL"));

    // MenuAP 
    this.itemsAPSetup = this.menuDataService.getMenuAPSetup(this.localStorageService.getItem("AccessFoAP"));
    this.itemsAPInput = this.menuDataService.getMenuAPInput(this.localStorageService.getItem("AccessFoAP"));
    this.itemsAPProcess = this.menuDataService.getMenuAPProcess(this.localStorageService.getItem("AccessFoAP"));
    this.itemsAPReport = this.menuDataService.getMenuAPReport(this.localStorageService.getItem("AccessFoAP"));
    this.itemsAPInquiry = this.menuDataService.getMenuAPInquiry(this.localStorageService.getItem("AccessFoAP"));

    // MenuAR 
    this.itemsARSetup = this.menuDataService.getMenuARSetup(this.localStorageService.getItem("AccessFoAR"));
    this.itemsARInput = this.menuDataService.getMenuARInput(this.localStorageService.getItem("AccessFoAR"));
    this.itemsARProcess = this.menuDataService.getMenuARProcess(this.localStorageService.getItem("AccessFoAR"));
    this.itemsARReport = this.menuDataService.getMenuARReport(this.localStorageService.getItem("AccessFoAR"));
    this.itemsARInquiry = this.menuDataService.getMenuARInquiry(this.localStorageService.getItem("AccessFoAR"));

    // MenuCA 
    this.itemsCASetup = this.menuDataService.getMenuCASetup(this.localStorageService.getItem("AccessFoCA"));
    this.itemsCAInput = this.menuDataService.getMenuCAInput(this.localStorageService.getItem("AccessFoCA"));
    this.itemsCAProcess = this.menuDataService.getMenuCAProcess(this.localStorageService.getItem("AccessFoCA"));
    this.itemsCAReport = this.menuDataService.getMenuCAReport(this.localStorageService.getItem("AccessFoCA"));
    this.itemsCAInquiry = this.menuDataService.getMenuCAInquiry(this.localStorageService.getItem("AccessFoCA"));

    // MenuFA 
    this.itemsFASetup = this.menuDataService.getMenuFASetup(this.localStorageService.getItem("AccessFoFA"));
    this.itemsFAInput = this.menuDataService.getMenuFAInput(this.localStorageService.getItem("AccessFoFA"));
    this.itemsFAProcess = this.menuDataService.getMenuFAProcess(this.localStorageService.getItem("AccessFoFA"));
    this.itemsFAReport = this.menuDataService.getMenuFAReport(this.localStorageService.getItem("AccessFoFA"));
    this.itemsFAInquiry = this.menuDataService.getMenuFAInquiry(this.localStorageService.getItem("AccessFoFA"));

    // MenuIN 
    this.itemsINSetup = this.menuDataService.getMenuINSetup(this.localStorageService.getItem("AccessFoIN"));
    this.itemsINInput = this.menuDataService.getMenuINInput(this.localStorageService.getItem("AccessFoIN"));
    this.itemsINProcess = this.menuDataService.getMenuINProcess(this.localStorageService.getItem("AccessFoIN"));
    this.itemsINReport = this.menuDataService.getMenuINReport(this.localStorageService.getItem("AccessFoIN"));

    // MenuSA 
    this.itemsSASetup = this.menuDataService.getMenuSASetup(this.localStorageService.getItem("AccessFoSA"));
    this.itemsSAInput = this.menuDataService.getMenuSAInput(this.localStorageService.getItem("AccessFoSA"));
    this.itemsSAReport = this.menuDataService.getMenuSAReport(this.localStorageService.getItem("AccessFoSA"));

    // MenuPO 
    this.itemsPOInput = this.menuDataService.getMenuPOInput(this.localStorageService.getItem("AccessFoPO"));
    this.itemsPOProcess = this.menuDataService.getMenuPOProcess(this.localStorageService.getItem("AccessFoPO"));
    this.itemsPOReport = this.menuDataService.getMenuPOReport(this.localStorageService.getItem("AccessFoPO"));

    // MenuSO 
    this.itemsSOInput = this.menuDataService.getMenuSOInput(this.localStorageService.getItem("AccessFoSO"));
    this.itemsSOProcess = this.menuDataService.getMenuSOProcess(this.localStorageService.getItem("AccessFoSO"));
    this.itemsSOReport = this.menuDataService.getMenuSOReport(this.localStorageService.getItem("AccessFoSO"));
    // Menu Einvoice
    this.itemsEISetup = this.menuDataService.getMenuEISetup(this.localStorageService.getItem("AccessFoEI"));
    this.itemsEIInput = this.menuDataService.getMenuEIInput(this.localStorageService.getItem("AccessFoEI"));
    this.itemsEIProcess = this.menuDataService.getMenuEIProcess(this.localStorageService.getItem("AccessFoEI"));

    // MenuSI 
    this.itemsSIInput = this.menuDataService.getMenuSIInput(this.localStorageService.getItem("AccessFoSI"));

    // MenuUF 
    this.itemsUFInput = this.menuDataService.getMenuUFInput(this.localStorageService.getItem("AccessFoUF"));

    // MenuST 
    this.itemsSTInput = this.menuDataService.getMenuSTInput(this.localStorageService.getItem("AccessFoST"));
    this.itemsSTSecurity = this.menuDataService.getMenuSTSecurity(this.localStorageService.getItem("AccessFoST"));

    // MenuBG
    this.itemsBGInput = this.menuDataService.getMenuBGInput(this.localStorageService.getItem("AccessFoBG"));
    this.itemsBGReport = this.menuDataService.getMenuBGReport(this.localStorageService.getItem("AccessFoBG"));

    // MenuSP
    this.itemsSPInput = this.menuDataService.getMenuSPInput(this.localStorageService.getItem("AccessFoSP"));
    this.itemsSPReport = this.menuDataService.getMenuSPReport(this.localStorageService.getItem("AccessFoSP"));

    // MenuCP
    this.itemsCPFinancialStatement = this.menuDataService.getMenuCPFinancialStatement(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPCustomers = this.menuDataService.getMenuCPCustomers(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPVendors = this.menuDataService.getMenuCPVendors(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPRevenues = this.menuDataService.getMenuCPRevenues(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPCost = this.menuDataService.getMenuCPCost(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPAnalyze = this.menuDataService.getMenuCPAnalyze(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPManagements = this.menuDataService.getMenuCPManagements(this.localStorageService.getItem("AccessFoCP"));
    this.itemsCPHumanResources = this.menuDataService.getMenuCPHumanResources(this.localStorageService.getItem("AccessFoCP"));
    // let a: CustomMenuItem[] = [];
    // a.push.apply(a, this.itemsGLSetup);
    // a.push.apply(a, this.itemsGLInput);
    // a.push.apply(a, this.itemsGLProcess);
    // a.push.apply(a, this.itemsGLReport);
    // a.push.apply(a, this.itemsGLInquiry);
    // a.push.apply(a, this.itemsAPSetup);
    // a.push.apply(a, this.itemsAPInput);
    // a.push.apply(a, this.itemsAPProcess);
    // a.push.apply(a, this.itemsAPReport);
    // a.push.apply(a, this.itemsAPInquiry);
    // a.push.apply(a, this.itemsARSetup);
    // a.push.apply(a, this.itemsARInput);
    // a.push.apply(a, this.itemsARProcess);
    // a.push.apply(a, this.itemsARReport);
    // a.push.apply(a, this.itemsARInquiry);
    // a.push.apply(a, this.itemsCASetup);
    // a.push.apply(a, this.itemsCAInput);
    // a.push.apply(a, this.itemsCAProcess);
    // a.push.apply(a, this.itemsCAReport);
    // a.push.apply(a, this.itemsCAInquiry);
    // a.push.apply(a, this.itemsFASetup);
    // a.push.apply(a, this.itemsFAInput);
    // a.push.apply(a, this.itemsFAProcess);
    // a.push.apply(a, this.itemsFAReport);
    // a.push.apply(a, this.itemsFAInquiry);
    // a.push.apply(a, this.itemsINSetup);
    // a.push.apply(a, this.itemsINInput);
    // a.push.apply(a, this.itemsINProcess);
    // a.push.apply(a, this.itemsINReport);
    // a.push.apply(a, this.itemsSASetup);
    // a.push.apply(a, this.itemsSAInput);
    // a.push.apply(a, this.itemsSAReport);
    // a.push.apply(a, this.itemsPOInput);
    // a.push.apply(a, this.itemsPOProcess);
    // a.push.apply(a, this.itemsPOReport);
    // a.push.apply(a, this.itemsSOInput);
    // a.push.apply(a, this.itemsSOProcess);
    // a.push.apply(a, this.itemsSOReport);
    // a.push.apply(a, this.itemsSIInput);
    // a.push.apply(a, this.itemsUFInput);
    // a.push.apply(a, this.itemsSTInput);
    // a.push.apply(a, this.itemsSTSecurity);
    // a.push.apply(a, this.itemsEISetup);
    // a.push.apply(a, this.itemsEIInput);
    // a.push.apply(a, this.itemsEIProcess);
    // a.push.apply(a, this.itemsBGInput);
    // a.push.apply(a, this.itemsBGReport);
    // a.push.apply(a, this.itemsSPInput);
    // a.push.apply(a, this.itemsSPReport);
    // // import("xlsx").then(xlsx => {
    // //   let worksheet;
    // //   worksheet = xlsx.utils.json_to_sheet(a);
    // //   const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    // //   const excelBuffer: any = xlsx.write(workbook, { bookType: 'csv', type: 'array' });
    // //   import("file-saver").then(FileSaver => {
    // //     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    // //     let EXCEL_EXTENSION = '.csv';
    // //     const data: Blob = new Blob([excelBuffer], {
    // //       type: EXCEL_TYPE
    // //     });
    // //     FileSaver.saveAs(data, "NameForm" + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    // //   });
    // // });

    // let b = [];
    // a.forEach(element => {
    //   let c: { Label: string, RouterLink: string, DescrVN: string, DescrEN: string } = { Label: '', RouterLink: "", DescrVN: "", DescrEN: "" } ;
    //   c.Label = element.Label;
    //   c.RouterLink = element.RouterLink;
    //   c.DescrVN = this.getMessage(element.Label);
    //   c.DescrEN = this.getMessage(element.Label);
    //   b.push(c);
    // });

    // import("xlsx").then(xlsx => {
    //   let worksheet;
    //   worksheet = xlsx.utils.json_to_sheet(b);
    //   const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //   const excelBuffer: any = xlsx.write(workbook, { bookType: 'csv', type: 'array' });
    //   import("file-saver").then(FileSaver => {
    //     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     let EXCEL_EXTENSION = '.csv';
    //     const data: Blob = new Blob([excelBuffer], {
    //       type: EXCEL_TYPE
    //     });
    //     FileSaver.saveAs(data, "Descr" + '_export_' + EXCEL_EXTENSION);
    //   });
    // });

    this.isMobileResolution = this.applicationStateService.getIsMobileResolution();
    if (this.isMobileResolution) {
      this.isMenuVisible = true;
    }
    else {
      this.isMenuVisible = true;
    }
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.loaderService.hide();
    // }, 1000);
  }

  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible
  }

}
